export default __webpack_public_path__ + "static/media/amazonia_quelate.0a214577.png";